export default __webpack_public_path__ + "static/media/preview_evito.becd7172.webp";